import { Component, OnInit, Input } from '@angular/core';
import { OHNElement } from '../../../models/ohn-instances';

@Component({
  selector: 'app-notes-element-config',
  templateUrl: './notes-element-config.component.html',
  styleUrls: ['./notes-element-config.component.scss'],
})
export class NotesElementConfigComponent implements OnInit {

	@Input() el: OHNElement;

  constructor() { }

  ngOnInit() {}

}
